import React from 'react'

const Sbs = () => {
  return (
    <div>Sbs</div>
  )
}

export default Sbs